define('vspot-angular/services/utilities-service',['angular'], function (ng) {
    'use strict';

    return ['resources.Utilities', '$log', function (Utilities, $log) {
        return {
            /*
             * Get a URL to send the user to for passing the baton to another user.
             * @param {int} activityId - id of the activity.
             * @returns Resource object.
             */
            getBatonURL:    function(activityId) {
                return Utilities.getBatonURL({ selected_activity: activityId });
            },

            /*
             * Get the short and long url for an activity.
             *
             * @returns  Resource object. See /resources.js documentation for details
             */
            getUrls: function (activityId) {
                return Utilities.getUrls({ selected_activity: activityId });
            },

            /*
             * Get the link to preview the activity as the participants would see it.
             *
             * @returns  Resource object. See /resources.js documentation for details
             */
            getInvitationLink: function (activityId) {
                return Utilities.getInvitationLink({ selected_activity: activityId });
            },

            /*
             * Set the email notification preferences for an activity
             *
             * @returns  Resource object. See /resources.js documentation for details
             */
            setEmailPreferences: function (postData) {
                return Utilities.setEmailPreferences(postData);
            },

            /*
             * Get the email notification preferences for an activity
             *
             * @returns  Resource object. See /resources.js documentation for details
             */
            getEmailPreferences: function (activityId) {
                return Utilities.getEmailPreferences({ selected_activity: activityId });
            },
            
            /*
             * Copy an activity, possibly to a new date
             *
             *  @param {int}  activityId - Id of the activity to copy
             *  @param {str}  newActivityName - Name for new activity
             *  @param {str}  newStartDate - New start date
             *  @param {bool} includPast - Include dates that are in the past?
             *  @param {bool} force - Should we force creation of an activity with a duplicate name?
             *  @param {bool} archive_original - after copying, archive the original
             *  @param {bool} swap_keys - after copying, swap keys so that links to the original go to the new one
             *
             * @returns  Resource object. See /resources.js documentation for details
             */
            copyActivity: function (activityId, newActivityName, newStartDate, includPast, force, archive_original, swap_keys) {
                return Utilities.copyActivity({
                    selected_activity:  activityId,
                    new_activity_name:  newActivityName,
                    new_start_date:     newStartDate,
                    include_past:       includPast,
                    force:              force === true ? true : false, // if force isn't true, treat it as false
                    archive_original:   archive_original,
                    swap_keys:          swap_keys
                });
            },

            yahooProxy: function (path, bearer) {
                return Utilities.yahooProxy({
                    path: path,
                    bearer: bearer
                });
            },
            /*
             * Call our proxy to the DirectorySpot API.
             *
             * @param username {string} - the user's username for directory spot.
             * @param password {string} - the user's password for directory spot.
             * @param path {string} - The API call to make.
             *
             * @returns  Resource object. See /resources.js documentation for details
             */
            directorySpotProxy: function (username, password, path) {
                return Utilities.directorySpotProxy({
                    username:   username,
                    password:   password,
                    path:       path
                });
            },

            /*
             *  Sends the volunteer hours report for the logged in user.
             *
             *  @param startDate {string} - What date to start the report from.
             *  @param endDate   {string} - What date to end the report.
             */
            hoursReport: function (startDate, endDate) {
                return Utilities.hoursReport({
                    startdate: startDate,
                    enddate: endDate
                });
            },

            /*
             *  Retrieve the pricing plans.
             *  @param all {bool} - Should we return all plans, or only available plans? Defaults to false.
             */
            pricingPlans: function (all) {
                if( all === undefined ) {
                    all = false;
                }
                var plans = Utilities.pricingPlans();

                var groups = {
                    // hard coding school... we'll add more below
                    school: {
                        name:     'Campus',
                        level:    3, // What if we change this?
                        plans:    {
                            monthly:  null,
                            annual:   null
                        },
                        adFree:   {
                            monthly:  null,
                            annual:   null
                        }
                    },
                    // Hard coding corporate... we'll add more below
                    corporate: {
                        name:     'Organization',
                        level:    3, // What if we change this?
                        plans:    {
                            monthly:  null,
                            annual:   null
                        },
                        adFree:   {
                            monthly:  null,
                            annual:   null
                        }
                    }
                };

                plans.$promise.then(function(result) {
                    if( result.status ) {
                        // Figure out the groups
                        var newLevel, tier;
                        for( var t=0, tLen=result.feature_tier_data.length; t<tLen; t++ ) {
                            tier = result.feature_tier_data[t];
                            if( tier.tier_level > 0 ) {
                                newLevel = 'level_' + tier.tier_level.toString(10);
                                groups[newLevel] = {
                                    name:     tier.tier_name,
                                    level:    tier.tier_level,
                                    plans:    {
                                        monthly:  null,
                                        annual:   null
                                    },
                                    adFree:   {
                                        monthly:  null,
                                        annual:   null
                                    }
                                };
                            }
                        }

                        // Group the plans together
                        var plan, levelName;
                        var newPlanData = [];
                        for( var p=0, pLen=result.plan_data.length; p<pLen; p++ ) {
                            plan = result.plan_data[p];
                            if( !all && !plan.available_for_viewing ) {
                                continue;
                            }

                            newPlanData.push(plan);
                            levelName = 'level_' + plan.tier_level.toString(10);
                            
                            if( plan.tier_level === 3 && plan.school ) {
                                // It's a school plan
                                levelName = 'school';
                            } else if( plan.tier_level === 3 && plan.corporate ) {
                                // It's a corporate plan
                                levelName = 'corporate';
                            }
                            
                            if( plan.ad_free ) {
                                if( plan.interval === 'month' ) {
                                    groups[levelName].adFree.monthly = plan;
                                } else if( plan.interval === 'year' ) {
                                    groups[levelName].adFree.annual = plan;
                                }
                            } else {
                                if( plan.interval === 'month' ) {
                                    groups[levelName].plans.monthly = plan;
                                } else if( plan.interval === 'year' ) {
                                    groups[levelName].plans.annual = plan;
                                }
                            }
                        }

                        // Now make sure the add-ons make sense
                        ng.forEach(groups, function(value, key) {
                            // Check the monthly
                            if( groups[key].adFree.monthly ) {
                                if( !groups[key].plans.monthly ) {
                                    // We have a monthly ad free, but not a monthly plan... what does that mean?
                                    $log.error("The plan '" + key + "' has a monthly ad free plan, but not a regular monthly plan. This doesn't make sense in the UI. Removing the monthly ad free plan.");
                                   // groups[key].adFree.monthly = null;
                                }
                            }

                            // Check the annual
                            if( groups[key].adFree.annual ) {
                                if( !groups[key].plans.annual ) {
                                    // We have a annual ad free, but not a annual plan... what does that mean?
                                    $log.error("The plan '" + key + "' has an annual ad free plan, but not a regular annual plan. This doesn't make sense in the UI. Removing the annual ad free plan.");
                                  //  groups[key].adFree.annual = null;
                                }
                            }
                        });

                        result.plan_data    = newPlanData;
                        result.groups       = groups;

                        var tmpF;
                        var maxTier = 0;
                        for( var f=0, fLen=result.feature_tier_data.length; f<fLen; f++ ) {
                            tmpF = result.feature_tier_data[f].tier_level;
                            if( tmpF > maxTier ) {
                                maxTier = tmpF;
                            }
                        }

                        // CEC - HACK for AD_FREE_ONLY_PREMIUM
                        //result.maxTier = maxTier;
                        result.maxTier = 3
                    } else {
                        result.groups   = {};
                        result.maxTier  = 0;
                    }
                });

                return plans;
            },

            /*
             *  Validate a promocode
             */
            validatePromoCode: function (promoCode) {
                return Utilities.validatePromoCode({
                    promocode: promoCode
                });
            },

            getUnsubscribePreferences: function(email) {
                return Utilities.getUnsubscribePreferences({
                    email: email
                });
            },

            updateUnsubscribePreferences: function(email, newsletter, organizerTip, noContact) {
                return Utilities.updateUnsubscribePreferences({
                    email:          email,
                    newsletter:     newsletter,
                    organizer_tip:  organizerTip,
                    no_contact:     noContact
                });
            }
        };
    }];
});

